import { IAppState } from '../../app.types';
import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './subscription.types';

const resourceSelectors = generateResourceSelectors<types.ISubscription>((state) => state.resource.subscription);

export const subscriptionSelectors = {
  ...resourceSelectors,
  selectCurrentSubscription: (state: IAppState): types.ISubscription | null => {
    return resourceSelectors.selectResourceList(state)[0] ?? null;
  },
};
